import * as THREE from 'three';
import { gsap } from 'gsap';

import * as mutationTypes from '../mutation-types';

const state = () => ({
  camera: {
    target: new THREE.Vector3(0,90,0),
    inst: null,
    near: 1,
    far: 1000,
    fov: 45,
    position: new THREE.Vector3(0,90,350),
    rotation: new THREE.Vector3(0,0,0)
  },
});

const getters = {
  camera: state => state.camera,
};

const mutations = {
  [mutationTypes.INIT_CAMERA] (state, camera) {
    state.camera.inst = camera;
  },
  // [mutationTypes.MOVE_DOLLY] (state, { y, z, render}) {
  //   gsap.to(state.camera.inst.position,{duration: 1, z: z, y: y, ease: 'ease.out' });
  //   state.camera.inst.updateProjectionMatrix();
  // }
};

const actions = {
  initCamera: ({ commit },payload) => {
    return new Promise( (resolve, reject) => {
      try {
        commit(mutationTypes.INIT_CAMERA,payload);
        resolve(payload);
      } catch (e) {
        reject(`An error happened: ${e}`);
      }
    })
  },
  zoommolo: ({ state, dispatch }, payload) => {

    let increment;

    switch (payload) {

      case '+':
        increment = 2;
        // console.log(state.camera.inst);
        break
      case '-':
        increment = -2;
        // console.log(state.camera.inst)
    }

    if( (state.camera.inst.zoom >= 10 && increment > 0) || (state.camera.inst.zoom <= 1 && increment < 0)) {
      return;
    }

    const onUpdate = () => {
      // console.log('on update!')
      state.camera.inst.updateProjectionMatrix();
      dispatch('render',null,{root:true});
    }


    gsap.to(state.camera.inst,{duration: 1, zoom: THREE.MathUtils.clamp((state.camera.inst.zoom + increment),1,10), onUpdate: onUpdate , ease: 'sine.inOut'});

  },
  fit: ({ state, dispatch }) => {
    const onUpdate = () => {
      dispatch('render',null,{root:true});
      state.camera.inst.updateProjectionMatrix();
    }

    gsap.to(state.camera.inst,{duration: 1, zoom: 1.5, ease: 'sine.inOut', onUpdate: onUpdate});
    gsap.to(state.camera.inst.position,{duration: 1, y: 90, ease: 'sine.inOut', onUpdate: onUpdate});
  },
  focusOnSelectedMesh: ({ state, dispatch },payload) => {

    const geometry = payload.geometry;

    // let boundingMax = new THREE.Vector3().clone(geometry.boundingBox.max);
    // let boundingMin = new THREE.Vector3().clone(geometry.boundingBox.min);

    // boundingMin = boundingMin*payload.parent.scale*payload.parent.rotation;
    // boundingMax = boundingMax*payload.parent.scale*payload.parent.rotation;

    

    const onUpdate = () => {
      dispatch('render',null,{root:true});
      state.camera.inst.updateProjectionMatrix();
    }

    if(geometry) {

      // moltiplico per lo scale del parent
      let y = geometry.boundingBox.max.y * payload.parent.scale.y/2 + geometry.boundingBox.min.y* payload.parent.scale.y/2;
      let height = geometry.boundingBox.max.y * payload.parent.scale.y - geometry.boundingBox.min.y*payload.parent.scale.y;
      // let y = boundingMax.y * payload.parent.scale.y/2 + boundingMin.y* payload.parent.scale.y/2;
      // let height = boundingMax.y * payload.parent.scale.y - boundingMin.y*payload.parent.scale.y;

      y = THREE.MathUtils.clamp(y,15,165); //fa in modo di sono superare questo range

      // console.log(height);
      let zoom;
      if(height > 100) {
        zoom = 2;
      } else if(height > 70) {
        zoom = 3;
      } else if(height > 40) {
        zoom = 4;
      } else {
        zoom = 6;
      }

      gsap.to(state.camera.inst.position, {duration: 1, y: y, ease: 'sine.inOut', onUpdate: onUpdate});
      gsap.to(state.camera.inst, {duration: 1, zoom: zoom, ease: 'sine.inOut', onUpdate: onUpdate});
    }

  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}